<template>
  <div class="flex min-h-screen flex-col text-black">
    <AuthDialog />
    <Profile />
    <SetUserDataDialog />
    <NotificationsDialog @close="closeNotificationDialog" />
    <SearchDialog :is-open="isSearchOpen" @close="isSearchOpen = false"  />

      <MyToastRepeatOrder v-if="user?.last_order_id > 0" :order-id="user?.last_order_id" />
      <AlertDialog />
  <ClientOnly>
      <OrderDialog />
      <CartAddDishAfterAuthorized />
  </ClientOnly>

      <MyLocationDialog
          :show="locationStore.showLocationDialog"
          @close="closeLocationModal"
      />

    <DocumentTextModal
      :show="modalsState.show_text"
      :type="modalsState.text_type"
      @close="closeModal('text_type')"
    />

    <header
      id="header"
      class="sticky left-0 right-0 top-0 z-40 h-16 bg-white bg-opacity-30 shadow-main backdrop-blur-sm lg:h-20"
    >
      <!-- desktop -->
      <div class="container mx-auto hidden h-full px-4 lg:flex lg:items-center" v-if="isLargeScreen">
        <div class="flex flex-1 items-center justify-start gap-5">
          <button
            class="group relative inline-block aspect-square h-8"
            @click="profileDialogStore.open()"
          >
            <IconUserDark class="absolute left-0 top-0 h-full opacity-100 transition-opacity group-hover:opacity-0" />
            <IconUserColor class="absolute left-0 top-0 h-full opacity-0 transition-opacity group-hover:opacity-100" />
          </button>
            <button @click="isSearchOpen = true">
                <IconSearchDark />
            </button>
          <ClientOnly>
            <MyLocation v-if="userCredentials.isAuthenticated" />
          </ClientOnly>

        </div>


        <div class="flex shrink grow-0 justify-center">
          <NuxtLink to="/">
            <img
              src="/logo.svg"
              class="h-10"
              alt="ВкусиЛосось"
            />
          </NuxtLink>
        </div>

        <div class="flex flex-1 items-center justify-end gap-2">

            <a
                v-if="siteInfo?.phone"
                :href="`tel:${siteInfo.phone}`"
                class="flex items-center gap-2 mgo-number-35276"
            >
                <IconPhoneCalling class="inline h-8" /> <span class="hidden xl:inline">{{ formatPhone(siteInfo.phone) }}</span>
            </a>
          <ClientOnly>
            <Order v-if="userCredentials.isAuthenticated" />
          </ClientOnly>
          <!-- <BonusCoins v-if="userCredentials.isAuthenticated" /> -->
            <div class="relative">
                <Menu>
                    <MenuButton><IconMenu class="inline h-8" /></MenuButton>
                    <MenuItems class="menu absolute flex w-[250px] gap-4 right-0 flex-col items-start rounded-xl bg-white p-8 shadow-main">
                        <MenuItem>
                            <button type="button" @click="routerLinkMethod('/promotions')">АКЦИИ<!-- <NuxtLink to="/promo">АКЦИИ</NuxtLink> --></button>
                        </MenuItem>
                        <MenuItem>
                            <button
                                type="button"
                                @click="openModal('delivery_conditions')"
                            >
                                УСЛОВИЯ ДОСТАВКИ
                            </button>
                        </MenuItem>
                        <!--
                        <MenuItem>
                            <button type="button" @click="routerLinkMethod('/blog')">БЛОГ<</button>
                        </MenuItem>
                        -->
                        <MenuItem>
                            <button
                                class="uppercase"
                                @click="profileDialogStore.open()"
                            >
                                ЛИЧНЫЙ КАБИНЕТ
                            </button>
                        </MenuItem>
                        <MenuItem>
                            <button
                                class="uppercase"
                                @click="profileDialogStore.open('orders_history')"
                            >
                                История заказов
                            </button>
                        </MenuItem>
                        <MenuItem>
                            <button
                                class="flex items-center uppercase"
                                @click="isModalOpen = true"
                            >
                                Оставить отзыв
                            </button>
                        </MenuItem>
                        <MenuItem>
                            <button
                                class="flex items-center uppercase"
                                @click="isModalWriteOpen = true"
                            >
                                Напишите нам
                            </button>
                        </MenuItem>
                    </MenuItems>
                </Menu>
            </div>
        </div>

      </div>

    <template v-if="isModalOpen">
        <LeaveFeedbackDialog
            :show="isModalOpen"
            @close="isModalOpen = false"
        />
    </template>

    <template v-if="isModalWriteOpen">
        <WriteUsDialog
            :show="isModalWriteOpen"
            @close="isModalWriteOpen = false"
        />
    </template>

      <!-- mobile -->
      <div class="container mx-auto flex h-full items-center justify-between px-4 lg:hidden">
        <div class="flex shrink grow-0 justify-center">
          <NuxtLink to="/">
            <img
              src="/main-logo.svg"
              class="h-8"
              alt="ВкусиЛосось"
            />
          </NuxtLink>
        </div>

        <div class="flex shrink-0 items-center justify-end gap-2">
            <a
                v-if="siteInfo?.phone"
                :href="`tel:${siteInfo.phone}`"
                class="flex items-center gap-2"
            >
                <IconPhoneCalling class="inline h-8" />

                <span class="hidden">{{ formatPhone(siteInfo.phone) }}</span>
            </a>

          <ClientOnly>
            <Order v-if="userCredentials.isAuthenticated" />
            <ShareCartDialog />
          </ClientOnly>
          <!-- <BonusCoins v-if="userCredentials.isAuthenticated" /> -->
          <button
            class="group relative inline-block aspect-square h-8"
            type="button"
            @click="profileDialogStore.open()"
          >
              <IconUserDark class="h-full" />
              <!--<IconUserDark class="absolute left-0 top-0 h-full opacity-100 transition-opacity group-hover:opacity-0" />
              <IconUserColor class="absolute left-0 top-0 h-full opacity-0 transition-opacity group-hover:opacity-100" />-->
          </button>
            <button @click="isSearchOpen = true">
                <IconSearchDark />
            </button>
            <div class="relative">
                <Menu>
                <MenuButton><IconMenu class="inline h-8" /></MenuButton>
                  <MenuItems class="menu absolute flex w-[250px] gap-4 right-0 flex-col items-start rounded-xl bg-white p-8 shadow-main">
                    <MenuItem>
                        <button type="button" @click="routerLinkMethod('/promotions')">АКЦИИ<!-- <NuxtLink to="/promo">АКЦИИ</NuxtLink> --></button>
                    </MenuItem>
                    <MenuItem>
                        <button
                            type="button"
                            @click="openModal('delivery_conditions')"
                        >
                            УСЛОВИЯ ДОСТАВКИ
                        </button>
                    </MenuItem>
                      <!-- <MenuItem>
                          <button type="button" @click="routerLinkMethod('/blog')">БЛОГ</button>
                    </MenuItem>-->
                    <MenuItem>
                        <button
                            class="uppercase"
                            @click="profileDialogStore.open()"
                        >
                            ЛИЧНЫЙ КАБИНЕТ
                        </button>
                    </MenuItem>
                    <MenuItem>
                        <button
                            class="flex items-center uppercase"
                            @click="isModalOpen = true"
                        >
                            Оставить отзыв
                        </button>
                    </MenuItem>
                    <MenuItem>
                        <button
                            class="flex items-center uppercase"
                            @click="isModalWriteOpen = true"
                        >
                            Напишите нам
                        </button>
                    </MenuItem>
                </MenuItems>
                </Menu>
            </div>
        </div>
      </div>

    </header>

    <div class="flex-1 basis-0">
      <NuxtPage />
    </div>

    <footer>
      <!-- desktop -->
      <div class="hidden bg-white py-9 shadow-[0_0_35px_0_rgba(0,0,0,0.05)] lg:block">
        <div class="container mx-auto flex items-center gap-8">
          <img
            src="/logo.svg"
            class="h-10"
            alt="ВкусиЛосось"
          />
          <div class="flex flex-col items-start gap-2 text-sm font-normal uppercase">

              <button
                  class="uppercase"
                  @click="profileDialogStore.open()"
              >
                  ЛИЧНЫЙ КАБИНЕТ
              </button>
            <NuxtLink to="/promotions">АКЦИИ</NuxtLink>
            <button
              type="button"
              @click="openModal('delivery_conditions')"
            >
              УСЛОВИЯ ДОСТАВКИ
            </button>
            <!--<NuxtLink to="/blog">БЛОГ</NuxtLink>-->
          </div>
          <div class="mr-auto flex flex-col items-start gap-2 text-sm font-normal uppercase">
            <LeaveFeedback />
            <WriteUs />
              <a href="https://t.me/vil_feedbot"
                 target="_blank"
                 class="flex items-center uppercase"
              >
                  Напишите в Телеграм
              </a>
          </div>
          <div class="flex flex-col gap-2 text-sm font-normal">
            <a
              v-if="siteInfo?.phone"
              :href="`tel:${siteInfo.phone}`"
              class="flex items-center gap-2"
            >
              <IconPhoneCalling class="inline h-8" /> {{ formatPhone(siteInfo.phone) }}
            </a>
            <a
              v-if="siteInfo?.email"
              :href="`mailto:${siteInfo.email}`"
              class="flex items-center gap-2"
            >
              <IconMail class="inline h-8" /> {{ siteInfo.email }}
            </a>
          </div>
          <div
            class="flex flex-col gap-4 text-sm font-normal uppercase"
          >
            <div>мы в соцсетях</div>
            <div class="flex items-center gap-4">
                <!--
              <a
                v-if="siteInfo?.youtube"
                :href="siteInfo.youtube"
                target="_blank"
              >
                <IconYouTube class="h-8" />
              </a>
              <a
                v-if="siteInfo?.viber"
                :href="siteInfo.viber"
                target="_blank"
              >
                <IconViber class="h-8" />
              </a>
              -->
              <a
                v-if="siteInfo?.vk"
                :href="siteInfo.vk"
                target="_blank"
              >
                <IconVK class="h-8" />
              </a>
              <a
                v-if="siteInfo?.whatsapp"
                :href="siteInfo.whatsapp"
                target="_blank"
              >
                <IconWhatsApp class="h-8" />
              </a>
                <a
                    href="https://t.me/vkus_i_losos"
                    target="_blank"
                >
                    <IconTG class="h-8" />
                </a>
            </div>
          </div>
        </div>
      </div>

      <!-- mobile -->
      <div class="bg-white py-5 shadow-[0_0_35px_0_rgba(0,0,0,0.05)] lg:hidden">
        <div class="container mx-auto flex justify-around gap-4 px-4">
          <div class="flex flex-col items-start justify-between gap-4">
            <img
              src="/main-logo.svg"
              class="h-8"
              alt="ВкусиЛосось"
            />
            <div class="flex flex-col gap-2 text-sm font-normal">
              <a
                v-if="siteInfo?.phone"
                :href="`tel:${siteInfo.phone}`"
                class="flex items-center gap-2"
              >
                <IconPhoneCalling class="inline h-4" /> {{ formatPhone(siteInfo.phone) }}
              </a>
              <a
                v-if="siteInfo?.email"
                :href="`mailto:${siteInfo.email}`"
                class="flex items-center gap-2"
              >
                <IconMail class="inline h-4" /> {{ siteInfo.email }}
              </a>
            </div>
            <div
              class="flex flex-col gap-2 text-sm font-normal uppercase"
            >
              <div>мы в соцсетях</div>
              <div class="flex items-center gap-2">
                <!--<a
                  v-if="siteInfo?.youtube"
                  :href="siteInfo.youtube"
                  target="_blank"
                >
                  <IconYouTube class="h-8" />
                </a>
                <a
                  v-if="siteInfo?.viber"
                  :href="siteInfo.viber"
                  target="_blank"
                >
                  <IconViber class="h-8" />
                </a>
                -->
                <a
                  v-if="siteInfo?.vk"
                  :href="siteInfo.vk"
                  target="_blank"
                >
                  <IconVK class="h-8" />
                </a>
                <a
                  v-if="siteInfo?.whatsapp"
                  :href="siteInfo.whatsapp"
                  target="_blank"
                >
                  <IconWhatsApp class="h-8" />
                </a>
                <a
                  href="https://t.me/vkus_i_losos"
                  target="_blank"
                >
                  <IconTG class="h-8" />
                </a>
              </div>
            </div>
          </div>

          <div class="flex flex-col items-start justify-between gap-2 leading-none">
            <NuxtLink to="/promotions">АКЦИИ</NuxtLink>
            <button
              type="button"
              @click="openModal('delivery_conditions')"
            >
              УСЛОВИЯ ДОСТАВКИ
            </button>
            <!--<NuxtLink to="/blog">БЛОГ</NuxtLink>-->

            <LeaveFeedback />
            <WriteUs />

              <a href="https://t.me/vil_feedbot"
                 target="_blank"
                 class="flex items-center uppercase"
              >
                  Напишите в Телеграм
              </a>
            <button
              class="uppercase"
              @click="profileDialogStore.open()"
            >
              ЛИЧНЫЙ КАБИНЕТ
            </button>
          </div>
        </div>
      </div>

      <div class="bg-gradient-to-r from-orange-200 to-orange-600 py-5">
        <div
          class="container mx-auto flex flex-col items-center gap-2 text-xs font-medium text-white lg:flex-row lg:gap-8"
        >
          <span>&copy; 2026 «ВкусиЛосось». Все права защищены.</span>
          <button
            type="button"
            @click="openModal('policy')"
          >
              Политика в отношении обработки персональных данных
          </button>
          <button
            type="button"
            @click="openModal('privacy_policy')"
          >
            Политика конфиденциальности
          </button>
          <button
            type="button"
            @click="openModal('personal_data_consent')"
          >
              Согласие на обработку персональных данных
          </button>
            <button
                type="button"
                @click="openModal('terms_of_sale')"
            >
                Условия продажи товаров
            </button>
        </div>
      </div>
    </footer>

      <div class="sticky left-0 right-0 bottom-0 z-40 h-16 bg-white bg-opacity-30 shadow-main backdrop-blur-sm lg:h-20" v-if="!isLargeScreen">

          <div class="container mx-auto flex h-full items-center justify-between px-8 lg:hidden">

                  <a
                      v-if="siteInfo?.phone"
                      :href="`tel:${siteInfo.phone}`"
                      class="flex items-center gap-2"
                  >
                      <IconPhoneCalling class="inline h-8" />

                      <span class="hidden">{{ formatPhone(siteInfo.phone) }}</span>
                  </a>

                  <ClientOnly>
                      <Order v-if="userCredentials.isAuthenticated" />
                      <ShareCartDialog />
                  </ClientOnly>
                  <!-- <BonusCoins v-if="userCredentials.isAuthenticated" /> -->
                  <button
                      class="group relative inline-block aspect-square h-8"
                      type="button"
                      @click="profileDialogStore.open()"
                  >
                      <IconUserDark class="h-full" />
                      <!--<IconUserDark class="absolute left-0 top-0 h-full opacity-100 transition-opacity group-hover:opacity-0" />
                      <IconUserColor class="absolute left-0 top-0 h-full opacity-0 transition-opacity group-hover:opacity-100" />-->
                  </button>
                  <div class="relative">
                      <Menu>
                          <MenuButton><IconMenu class="inline h-8" /></MenuButton>
                          <MenuItems class="menu absolute flex w-[250px] gap-4 right-0 bottom-10 flex-col items-start rounded-xl bg-white p-8 shadow-main">
                              <MenuItem>
                                  <button type="button" @click="routerLinkMethod('/promotions')">АКЦИИ<!-- <NuxtLink to="/promo">АКЦИИ</NuxtLink> --></button>
                              </MenuItem>
                              <MenuItem>
                                  <button
                                      type="button"
                                      @click="openModal('delivery_conditions')"
                                  >
                                      УСЛОВИЯ ДОСТАВКИ
                                  </button>
                              </MenuItem>
                              <!-- <MenuItem>
                                  <button type="button" @click="routerLinkMethod('/blog')">БЛОГ</button>
                            </MenuItem>-->
                              <MenuItem>
                                  <button
                                      class="uppercase"
                                      @click="profileDialogStore.open()"
                                  >
                                      ЛИЧНЫЙ КАБИНЕТ
                                  </button>
                              </MenuItem>
                              <MenuItem>
                                  <button
                                      class="flex items-center uppercase"
                                      @click="isModalOpen = true"
                                  >
                                      Оставить отзыв
                                  </button>
                              </MenuItem>
                              <MenuItem>
                                  <button
                                      class="flex items-center uppercase"
                                      @click="isModalWriteOpen = true"
                                  >
                                      Напишите нам
                                  </button>
                              </MenuItem>
                          </MenuItems>
                      </Menu>
                  </div>
          </div>

      </div>
  </div>

        <template v-if="showPrivacyContent == undefined">
            <div class="fixed z-[31] border-[1px] flex-col gap-5 text-xs sm:text-base items-center lg:flex-row border-gray bottom-20 bg-white mx-auto inset-x-0 flex md:w-5/6 lg:w-3/4 xl:w-1/2 p-5 rounded-3xl shadow-[0_0_35px_0_rgba(0,0,0,0.05)]">
                <div>
                    Для улучшения работы сайта и его взаимодействия с пользователями мы используем файлы сооkіе. Продолжая работу с сайтом, Вы разрешаете использование cookie-файлов в соответствии с <button
                    type="button"
                    class="text-orange-200 cursor-pointer"
                    @click="openModal('privacy_policy')"
                >
                    Политикой конфиденциальности.
                </button> Вы всегда можете отключить файлы соokіе в настройках Вашего браузера.
                </div>
                <div>
                    <SimpleButton class="rounded-full text-xs sm:text-base border-2 border-transparent bg-clip-padding px-8 py-4 transition-colors font-medium text-white" @click="showPrivacyContent = '1'">
                        ПРИНЯТЬ
                    </SimpleButton>

                </div>

            </div>
        </template>


</template>

<script setup lang="ts">
import { useProfileDialogStore } from '~/store/profileDialog'
import { formatPhone } from '~/utils'
import { useSetDataDialog } from '~/store/setDataDialog'
import { useAuthDialogStore } from '~/store/authDialog'
import { Menu, MenuButton, MenuItems, MenuItem } from '@headlessui/vue'
import { ref } from 'vue'
import { useCartDialogStore } from '~/store/cartDialog'
import { useToast } from 'vue-toastification'
import MyToast from '~/components/MyToast.vue'
import { useFillFromOrder } from '~/composables/api/basket'
import DocumentTextModal from '~/components/DocumentTextModal.vue'
import { useLocationStore } from '~/store/location'

const isLargeScreen = useTailwindBreakpoint('lg')
const router = useRouter()
const isSearchOpen = ref(false)

const modalsState = computed(() => ({
  text_type: router.currentRoute.value.query.text_type,
  show_text: 'text_type' in router.currentRoute.value.query,
}))
const openModal = (key: string) => {
  router.push({
    query: {
      ['text_type']: key,
    },
  })
}
const closeModal = (key: string) => {
  router.push({
    query: {
      ...router.currentRoute.value.query,
      ['text_type']: undefined,
      ['show_text']: undefined,
    },
  })
}
const profileDialogStore = useProfileDialogStore()
const locationStore = useLocationStore()
const closeLocationModal = () => (locationStore.showLocationDialog = false)

const cartDialogStore = useCartDialogStore()

const { userCredentials } = useUserCredentials()
const setDataDialogStore = useSetDataDialog()
const authDialogStore = useAuthDialogStore()

const isModalOpen = ref(false)
const isModalWriteOpen = ref(false)
const routerLinkMethod = function(href: string) {
    router.push(href);
}
const toast = useToast()

const { mutate } = useFillFromOrder()

if(userCredentials.value.accessToken == "") {
    userCredentials.value = {
        accessToken: '',
        refreshToken: '',
        isAuthenticated: false,
    }
}

const showChat = () => {
    const element = document.querySelector('[data-b24-crm-button-widget="openline_livechat"]');
    if (element) {
        element.click();
    }
}

const showAddressDialogCookie = useCookie('show_address_dialog', {
    watch: 'shallow',
    expires: new Date(new Date().getTime() + 7 * 60 * 60 * 24 * 1000),
})

const closeNotificationDialog = () => {
    if(user.value?.show_address_dialog && showAddressDialogCookie.value != 1) {
        locationStore.showLocationDialog = true
        showAddressDialogCookie.value = 1
    }
}

const { data: user } = useUser((v) =>  v as any)
watch(
  [user, userCredentials],
  () => {
      if (userCredentials.value.isAuthenticated) {
          authDialogStore.close()
          if (user.value?.need_more_user_data && showSetDataDialog.value != "1") {
              setDataDialogStore.open()
              showSetDataDialog.value = "1"
          }
      }
  },
  {
    immediate: true,
  }
)

let showSetDataDialogExpirationDate = new Date()
showSetDataDialogExpirationDate.setDate(showSetDataDialogExpirationDate.getDate()+1)

const showSetDataDialog = useCookie('show_set_data_dialog', {
    watch: true,
    expires: showSetDataDialogExpirationDate,
})

const cookieExpirationDate = new Date();
cookieExpirationDate.setFullYear(cookieExpirationDate.getFullYear() + 1);
const showPrivacyContent = useCookie('show_privacy_consent', {
    watch: true,
    expires: cookieExpirationDate,
})

const { data: siteInfo, suspense } = useSiteInfo((v) => v)

onServerPrefetch(async () => {
  await suspense()
})
</script>
